var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 56,
    viewBox: "0 0 48 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9808 16.0991C44.9417 15.7069 44.8029 15.3311 44.5774 15.0066C44.3519 14.6822 44.047 14.4198 43.6914 14.2441L24.8675 4.91073C24.5406 4.74852 24.1801 4.66406 23.8146 4.66406C23.449 4.66406 23.0885 4.74852 22.7616 4.91073L3.93773 14.2441C3.58307 14.4208 3.27916 14.6835 3.05416 15.0078C2.82917 15.3321 2.69037 15.7074 2.65065 16.0991C2.62476 16.3487 0.38943 41.2221 22.8604 51.1317C23.1607 51.2661 23.4863 51.3356 23.8157 51.3356C24.1452 51.3356 24.4708 51.2661 24.771 51.1317C47.242 41.2221 45.0067 16.3511 44.9808 16.0991ZM23.8157 46.4254C7.88839 38.7907 7.13544 22.4971 7.26485 17.8141L23.8157 9.60773L40.3549 17.8094C40.4419 22.4504 39.5831 38.8514 23.8157 46.4254Z",
    fill: "#2CC66D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4608 29.3686L16.0654 24.0182L12.7383 27.3176L21.4608 35.9672L34.8893 22.6509L31.5622 19.3516L21.4608 29.3686Z",
    fill: "#2CC66D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShield);
export default __webpack_public_path__ + "static/media/icon-shield.d5523143c28e3572cfefa59eac439ba4.svg";
export { ForwardRef as ReactComponent };